import React from 'react';
import { BsX, BsShieldCheck, BsKey, BsPersonGear } from 'react-icons/bs';

interface HelpDrawerContaServicoProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={{ marginBottom: '20px' }}>
    <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', borderBottom: '1px solid #eee', paddingBottom: '6px' }}>
      {title}
    </h4>
    <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.6' }}>{children}</div>
  </div>
);

const DRAWER_WIDTH = 320;

const HelpDrawerContaServico: React.FC<HelpDrawerContaServicoProps> = ({ isOpen, onClose, children }) => {
  return (
    <>
      <div style={{ marginRight: isOpen ? DRAWER_WIDTH : 0, transition: 'margin-right 0.3s ease' }}>
        {children}
      </div>

      <div style={{
        position: 'fixed',
        top: 0,
        right: isOpen ? 0 : -DRAWER_WIDTH,
        width: DRAWER_WIDTH,
        height: '100vh',
        backgroundColor: '#fff',
        borderLeft: '1px solid #e0e0e0',
        boxShadow: '-2px 0 8px rgba(0,0,0,0.08)',
        transition: 'right 0.3s ease',
        zIndex: 1050,
        display: 'flex',
        flexDirection: 'column',
      }}>
        <div style={{
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'linear-gradient(180deg, #2a2d3a 0%, #3c3f4c 100%)',
          color: '#fff',
        }}>
          <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '600' }}>Ajuda — Contas de Serviço</h3>
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '18px', cursor: 'pointer', padding: '0 4px' }}
          >
            <BsX />
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px', fontSize: '13px' }}>
          <Section title="Visão Geral">
            <p style={{ margin: 0 }}>
              Contas de Serviço são credenciais institucionais para integração automatizada com o Identifica. Permitem que sistemas externos enviem candidatos, fotos e consultem dados de bancas.
            </p>
          </Section>

          <Section title="Abas">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                <BsShieldCheck style={{ flexShrink: 0, marginTop: '2px', color: '#0d6efd' }} />
                <div>
                  <strong>Solicitações Pendentes</strong>
                  <div style={{ color: '#666', fontSize: '12px' }}>Avalie solicitações de novas contas. Clique em "Avaliar" para aprovar ou rejeitar.</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                <BsKey style={{ flexShrink: 0, marginTop: '2px', color: '#198754' }} />
                <div>
                  <strong>Contas de Serviço</strong>
                  <div style={{ color: '#666', fontSize: '12px' }}>Lista todas as contas ativas e revogadas. Gerencie permissões e revogue contas quando necessário.</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                <BsPersonGear style={{ flexShrink: 0, marginTop: '2px', color: '#6c757d' }} />
                <div>
                  <strong>Perfis de Conta de Serviço</strong>
                  <div style={{ color: '#666', fontSize: '12px' }}>Gerencie os perfis de integração e suas permissões associadas.</div>
                </div>
              </div>
            </div>
          </Section>

          <Section title="Solicitações Pendentes">
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
              <li><strong>Descrição:</strong> Identificação da conta.</li>
              <li><strong>Unidade:</strong> Unidade solicitante.</li>
              <li><strong>Perfil:</strong> Tipo de acesso solicitado e suas permissões.</li>
              <li><strong>Acesso Multi-Unidade:</strong> Se a conta acessará dados de outras unidades.</li>
              <li><strong>Avaliar:</strong> Abre o formulário para aprovar ou rejeitar.</li>
            </ul>
          </Section>

          <Section title="Contas de Serviço">
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
              <li><strong>client_id:</strong> Identificador único da conta (usado na integração).</li>
              <li><strong>Responsável:</strong> Pessoa que solicitou a conta.</li>
              <li><strong>Status:</strong> Ativa, Revogada ou Expirada.</li>
              <li><strong>Revogar:</strong> Desativa a conta permanentemente.</li>
            </ul>
          </Section>

          <Section title="Perfis de Integração">
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
              <li><strong>Integração de Candidatos:</strong> Envio de candidatos e consulta de bancas.</li>
              <li><strong>Integração Completa:</strong> Candidatos + upload de fotos.</li>
              <li>Cada perfil tem permissões específicas listadas na tabela.</li>
            </ul>
          </Section>

          <Section title="Dicas">
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
              <li>Apenas administradores podem acessar esta tela.</li>
              <li>Contas revogadas não podem ser reativadas.</li>
              <li>O responsável é notificado por email em caso de mudança de vínculo.</li>
              <li>Contas com expiração definida são desativadas automaticamente.</li>
            </ul>
          </Section>
        </div>
      </div>
    </>
  );
};

export default HelpDrawerContaServico;
